"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _MapBrowserEvent = _interopRequireDefault(require("./MapBrowserEvent.js"));

var _MapBrowserEventType = _interopRequireDefault(require("./MapBrowserEventType.js"));

var _EventType2 = _interopRequireDefault(require("./pointer/EventType.js"));

var _Target = _interopRequireDefault(require("./events/Target.js"));

var _has = require("./has.js");

var _functions = require("./functions.js");

var _events = require("./events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/MapBrowserEventHandler
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var MapBrowserEventHandler =
/** @class */
function (_super) {
  __extends(MapBrowserEventHandler, _super);
  /**
   * @param {import("./PluggableMap.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */


  function MapBrowserEventHandler(map, moveTolerance) {
    var _this = _super.call(this, map) || this;
    /**
     * This is the element that we will listen to the real events on.
     * @type {import("./PluggableMap.js").default}
     * @private
     */


    _this.map_ = map;
    /**
     * @type {any}
     * @private
     */

    _this.clickTimeoutId_;
    /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */

    _this.emulateClicks_ = false;
    /**
     * @type {boolean}
     * @private
     */

    _this.dragging_ = false;
    /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */

    _this.dragListenerKeys_ = [];
    /**
     * @type {number}
     * @private
     */

    _this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
    /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */

    _this.down_ = null;

    var element = _this.map_.getViewport();
    /**
     * @type {number}
     * @private
     */


    _this.activePointers_ = 0;
    /**
     * @type {!Object<number, boolean>}
     * @private
     */

    _this.trackedTouches_ = {};
    _this.element_ = element;
    /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */

    _this.pointerdownListenerKey_ = (0, _events.listen)(element, _EventType2["default"].POINTERDOWN, _this.handlePointerDown_, _this);
    /**
     * @type {PointerEvent}
     * @private
     */

    _this.originalPointerMoveEvent_;
    /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */

    _this.relayedListenerKey_ = (0, _events.listen)(element, _EventType2["default"].POINTERMOVE, _this.relayEvent_, _this);
    /**
     * @private
     */

    _this.boundHandleTouchMove_ = _this.handleTouchMove_.bind(_this);

    _this.element_.addEventListener(_EventType["default"].TOUCHMOVE, _this.boundHandleTouchMove_, _has.PASSIVE_EVENT_LISTENERS ? {
      passive: false
    } : false);

    return _this;
  }
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.emulateClick_ = function (pointerEvent) {
    var newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].CLICK, this.map_, pointerEvent);
    this.dispatchEvent(newEvent);

    if (this.clickTimeoutId_ !== undefined) {
      // double-click
      clearTimeout(this.clickTimeoutId_);
      this.clickTimeoutId_ = undefined;
      newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].DBLCLICK, this.map_, pointerEvent);
      this.dispatchEvent(newEvent);
    } else {
      // click
      this.clickTimeoutId_ = setTimeout(
      /** @this {MapBrowserEventHandler} */
      function () {
        this.clickTimeoutId_ = undefined;
        var newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].SINGLECLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
      }.bind(this), 250);
    }
  };
  /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.updateActivePointers_ = function (pointerEvent) {
    var event = pointerEvent;

    if (event.type == _MapBrowserEventType["default"].POINTERUP || event.type == _MapBrowserEventType["default"].POINTERCANCEL) {
      delete this.trackedTouches_[event.pointerId];
    } else if (event.type == _MapBrowserEventType["default"].POINTERDOWN) {
      this.trackedTouches_[event.pointerId] = true;
    }

    this.activePointers_ = Object.keys(this.trackedTouches_).length;
  };
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.handlePointerUp_ = function (pointerEvent) {
    this.updateActivePointers_(pointerEvent);
    var newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].POINTERUP, this.map_, pointerEvent);
    this.dispatchEvent(newEvent); // We emulate click events on left mouse button click, touch contact, and pen
    // contact. isMouseActionButton returns true in these cases (evt.button is set
    // to 0).
    // See http://www.w3.org/TR/pointerevents/#button-states
    // We only fire click, singleclick, and doubleclick if nobody has called
    // event.preventDefault().

    if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) {
      this.emulateClick_(this.down_);
    }

    if (this.activePointers_ === 0) {
      this.dragListenerKeys_.forEach(_events.unlistenByKey);
      this.dragListenerKeys_.length = 0;
      this.dragging_ = false;
      this.down_ = null;
    }
  };
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */


  MapBrowserEventHandler.prototype.isMouseActionButton_ = function (pointerEvent) {
    return pointerEvent.button === 0;
  };
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.handlePointerDown_ = function (pointerEvent) {
    this.emulateClicks_ = this.activePointers_ === 0;
    this.updateActivePointers_(pointerEvent);
    var newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].POINTERDOWN, this.map_, pointerEvent);
    this.dispatchEvent(newEvent); // Store a copy of the down event

    this.down_ =
    /** @type {PointerEvent} */
    {};

    for (var property in pointerEvent) {
      var value = pointerEvent[property];
      this.down_[property] = typeof value === 'function' ? _functions.VOID : value;
    }

    if (this.dragListenerKeys_.length === 0) {
      var doc = this.map_.getOwnerDocument();
      this.dragListenerKeys_.push((0, _events.listen)(doc, _MapBrowserEventType["default"].POINTERMOVE, this.handlePointerMove_, this), (0, _events.listen)(doc, _MapBrowserEventType["default"].POINTERUP, this.handlePointerUp_, this),
      /* Note that the listener for `pointercancel is set up on
       * `pointerEventHandler_` and not `documentPointerEventHandler_` like
       * the `pointerup` and `pointermove` listeners.
       *
       * The reason for this is the following: `TouchSource.vacuumTouches_()`
       * issues `pointercancel` events, when there was no `touchend` for a
       * `touchstart`. Now, let's say a first `touchstart` is registered on
       * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
       * But `documentPointerEventHandler_` doesn't know about the first
       * `touchstart`. If there is no `touchend` for the `touchstart`, we can
       * only receive a `touchcancel` from `pointerEventHandler_`, because it is
       * only registered there.
       */
      (0, _events.listen)(this.element_, _MapBrowserEventType["default"].POINTERCANCEL, this.handlePointerUp_, this));

      if (this.element_.getRootNode && this.element_.getRootNode() !== doc) {
        this.dragListenerKeys_.push((0, _events.listen)(this.element_.getRootNode(), _MapBrowserEventType["default"].POINTERUP, this.handlePointerUp_, this));
      }
    }
  };
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.handlePointerMove_ = function (pointerEvent) {
    // Between pointerdown and pointerup, pointermove events are triggered.
    // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
    // moved a significant distance.
    if (this.isMoving_(pointerEvent)) {
      this.dragging_ = true;
      var newEvent = new _MapBrowserEvent["default"](_MapBrowserEventType["default"].POINTERDRAG, this.map_, pointerEvent, this.dragging_);
      this.dispatchEvent(newEvent);
    }
  };
  /**
   * Wrap and relay a pointer event.  Note that this requires that the type
   * string for the MapBrowserEvent matches the PointerEvent type.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */


  MapBrowserEventHandler.prototype.relayEvent_ = function (pointerEvent) {
    this.originalPointerMoveEvent_ = pointerEvent;
    var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
    this.dispatchEvent(new _MapBrowserEvent["default"](pointerEvent.type, this.map_, pointerEvent, dragging));
  };
  /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */


  MapBrowserEventHandler.prototype.handleTouchMove_ = function (event) {
    // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
    // may not be initialized yet when we get here on a platform without native pointer events.
    var originalEvent = this.originalPointerMoveEvent_;

    if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) {
      event.preventDefault();
    }
  };
  /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */


  MapBrowserEventHandler.prototype.isMoving_ = function (pointerEvent) {
    return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
  };
  /**
   * Clean up.
   */


  MapBrowserEventHandler.prototype.disposeInternal = function () {
    if (this.relayedListenerKey_) {
      (0, _events.unlistenByKey)(this.relayedListenerKey_);
      this.relayedListenerKey_ = null;
    }

    this.element_.removeEventListener(_EventType["default"].TOUCHMOVE, this.boundHandleTouchMove_);

    if (this.pointerdownListenerKey_) {
      (0, _events.unlistenByKey)(this.pointerdownListenerKey_);
      this.pointerdownListenerKey_ = null;
    }

    this.dragListenerKeys_.forEach(_events.unlistenByKey);
    this.dragListenerKeys_.length = 0;
    this.element_ = null;

    _super.prototype.disposeInternal.call(this);
  };

  return MapBrowserEventHandler;
}(_Target["default"]);

var _default = MapBrowserEventHandler;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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